import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
export type JobSeekerProfileFragment = { __typename?: 'JobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null, defaultInfo?: { __typename?: 'JobSeekerProfileDefaultInfo', contactInformation?: { __typename?: 'JobSeekerProfileContactInformation', location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, address2?: string | null, admin1?: string | null, admin2?: string | null, admin3?: string | null, admin4?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, fullFormattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null } | null } | null, resume: Array<{ __typename?: 'JobSeekerProfileResume', id: string, location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, address2?: string | null, admin1?: string | null, admin2?: string | null, admin3?: string | null, admin4?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, fullFormattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null }>, subscription?: { __typename?: 'JobSeekerProfileSubscription', status?: Types.JobSeekerProfileSubscriptionStatus | null } | null, jsProPremiumAccess?: { __typename?: 'JsProPremiumAccess', applicantInsights?: { __typename?: 'JsProPremiumAccessResult', access?: Types.JsProPremiumAccessStatus | null } | null } | null } | null };

export const JobSeekerProfileFragmentDoc = gql`
    fragment JobSeekerProfile on JobSeekerProfilePayload {
  profile {
    accountKey
    defaultInfo {
      contactInformation {
        location {
          address
          address2
          admin1
          admin2
          admin3
          admin4
          city
          country
          state
          postalCode
          formattedLocation
          fullFormattedLocation
          latitude
          longitude
          geocodePrecision
        }
      }
    }
    resume {
      id
      location {
        address
        address2
        admin1
        admin2
        admin3
        admin4
        city
        country
        state
        postalCode
        formattedLocation
        fullFormattedLocation
        latitude
        longitude
        geocodePrecision
      }
    }
    subscription {
      status
    }
    jsProPremiumAccess {
      applicantInsights {
        access
      }
    }
  }
}
    `;